import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dialogue-modal-mask" }
const _hoisted_2 = { class: "dialogue-modal-wrapper" }
const _hoisted_3 = { class: "dialogue-overlay" }
const _hoisted_4 = { class: "dialogue dialogue-modal-content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["disabled", "onClick"]

import { ref } from "vue";
import { ButtonTypes, Button as ButtonVM } from "@/models/modal";
import DOMPurify from "dompurify";
import Icon from "@/components/shared/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomDialogueModal',
  props: {
    loading: { type: Boolean, default: false },
    options: {},
    footerStyle: { default: "center" },
    closeBtn: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const containerRef = ref<HTMLDivElement | null>();
const descriptionRef = ref<HTMLDivElement | null>();
const footerRef = ref<HTMLDivElement | null>();
const headerRef = ref<HTMLDivElement | null>();

__expose({
  props,
  containerRef,
  descriptionRef,
  footerRef,
  headerRef,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "dialogue-modal-container",
        ref_key: "containerRef",
        ref: containerRef
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("header", {
              class: "dialogue-modal-header",
              ref_key: "headerRef",
              ref: headerRef
            }, [
              (!__props.options.hideTitle)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(__props.options.title), 1))
                : _createCommentVNode("", true)
            ], 512),
            (__props.closeBtn)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 0,
                  icon: "x-bold fa-close",
                  alt: "Close modal button",
                  class: "close-btn",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]))
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "dialogue-msg dialogue-modal-description",
              ref_key: "descriptionRef",
              ref: descriptionRef
            }, [
              _createElementVNode("div", {
                innerHTML: _unref(DOMPurify).sanitize(__props.options.description || '')
              }, null, 8, _hoisted_6)
            ], 512),
            _createElementVNode("div", {
              class: _normalizeClass(["footer dialogue-modal-footer", __props.footerStyle]),
              ref_key: "footerRef",
              ref: footerRef
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options.buttons, (btn) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: btn.label,
                  class: _normalizeClass([
                  btn.classStyle,
                  { isLoading: btn.type === _unref(ButtonTypes).Confirm && __props.loading },
                ]),
                  disabled: __props.loading,
                  onClick: _withModifiers(btn.onClick, ["prevent"])
                }, [
                  _createElementVNode("span", null, _toDisplayString(btn.label), 1)
                ], 10, _hoisted_7))
              }), 128))
            ], 2)
          ])
        ])
      ], 512)
    ])
  ]))
}
}

})